import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import { IColors } from '@src/types/theme';
import { getColorTheme } from '@src/store/selectors/theme';
import { formatToTimestamp } from '@src/utils/time';

import { TimerIcon } from '@src/components/common/icon';
import Timer from '@src/components/common/timer';

const CountdownWrapper = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
`;

const StyledTimerIcon = styled(TimerIcon)`
	@media ${props => props.theme.device.mobile} {
		width: 60px;
		height: 60px;
	}
`;

const StyledTimer = styled(Timer)`
	margin-left: 12px;

	@media ${props => props.theme.device.mobile} {
		margin-left: 8px;
	}
`;

interface ISlotSelection {
	className?: string;
	time: string;
	fontSize?: {
		numberSize?: number;
		unitSize?: number;
	};
	fontWeight?: number;
}

const SaleCountdown = ({ className, time, fontSize, fontWeight }: ISlotSelection): JSX.Element => {
	const { t } = useTranslation();
	const { colors } = useSelector(getColorTheme) as { colors: IColors };

	return (
		<CountdownWrapper className={className}>
			<StyledTimerIcon mainColor={colors.primary} />
			<StyledTimer
				timerTitle={t('event:countdown_for_sale')}
				endTime={formatToTimestamp(time)}
				fontSize={fontSize}
				fontWeight={fontWeight}
			/>
		</CountdownWrapper>
	);
};

export default SaleCountdown;
